import React, { useState, useEffect, useRef } from 'react'
import styles from '../CSS/AgentHome.module.css';

import { GoArrowRight } from "react-icons/go";

import { useNavigate } from "react-router-dom";
import { useAuth } from '../AuthContext';

import Loading from '../Components/Loading';
import Error from '../Components/Error';

const UserData = () => {
  const navigate = useNavigate();
  const { postData, fetchData } = useAuth();

  let path = window.location.hash
  const getParams = path.split('?')[1]
  const query = new URLSearchParams(getParams);
  const userId = query.get('userId')

  const [email, setEmail] = useState('');
  const [role, setRole] = useState('user');
  const [limit, setLimit] = useState(0)

  const [lv1, setLv1] = useState({
    deposit: 0,
    withdraw: 0,
    users: 0,
    commission: 0
  })

  const [lv2, setLv2] = useState({
    deposit: 0,
    withdraw: 0,
    users: 0,
    commission: 0
  })

  const [lv3, setLv3] = useState({
    deposit: 0,
    withdraw: 0,
    users: 0,
    commission: 0
  })

  const [loader, setLoader] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorText, setErrorText] = useState('');

  const [records, setRecords] = useState([])
  const [balance, setBalance] = useState({
    deposit: 0,
    withdraw: 0
  });

  const [betting, setBetting] = useState({
    company: 0,
    amount: 0
  });

  const [winning, setWinning] = useState({
    amount: 0,
    no: 0
  })

  const [deposit, setDeposit] = useState(0);

  const [withdraw, setWithdraw] = useState(0);

  const displayError = (message) => {
    setIsError(true);
    setErrorText(message);

    const timerId = setTimeout(() => {
      setIsError(false);
      setErrorText('');
    }, 1500);

    return () => clearTimeout(timerId);
  };

  const isFirstRun = useRef(true);
  async function getData() {
    setLoader(true);

    try {
      const data = await fetchData('/admin/user/details?userId=' + userId);
      setLoader(false);

      setEmail(data.email)
      setBalance({
        deposit: data.balance.deposit,
        withdraw: data.balance.withdraw
      });

      setDeposit(data.status.deposits);
      setWithdraw(data.status.withdrawals);
      setBetting({
        company: data.status.betting.company,
        amount: data.status.betting.amount
      });

      setLimit(data.limit)

      setWinning({
        amount: data.status.winnings.amount,
        no: data.status.winnings.no
      })

      setLv1({
        deposit: data.referral.team1.deposits,
        withdraw: data.referral.team1.withdrawal,
        users: data.referral.team1.user,
        commission: data.referral.team1.commission
      })

      setLv2({
        deposit: data.referral.team2.deposits,
        withdraw: data.referral.team2.withdrawal,
        users: data.referral.team2.user,
        commission: data.referral.team2.commission
      })

      setLv3({
        deposit: data.referral.team3.deposits,
        withdraw: data.referral.team3.withdrawal,
        users: data.referral.team3.user,
        commission: data.referral.team3.commission
      })

      setRecords(data.records || []);

      setRole(data.role)
    } catch (error) {
      setLoader(false);
      displayError(error.message)
    }
  }

  useEffect(() => {
    if (isFirstRun.current) {
      getData();
      isFirstRun.current = false;
    }
  }, [])

  async function sendData(promote, li) {
    let score = ''
    if (li) {
      score = prompt("Please enter withdrawal limit for this leader:");

      if (score === null || isNaN(score)) {
        alert("Invalid limit. Please enter a valid amount");
        return;
      }

      if (score < 2) {
        alert("Limit cannot be less than $2 USD");
        return;
      }
    }

    setLoader(true);

    try {
      const data = await postData('/admin/user/promote', { promote, userId, limit: score });
      setLoader(false);

      setRole(data.role);
      setLimit(data.limit)
    } catch (error) {
      setLoader(false);
      displayError(error.message)
    }
  }

  return (
    <div className='dashboard'>
      {loader && <Loading />}
      {isError && <Error errorMsg={errorText} />}

      <div className={styles.topbar}>
        <div className={styles.left}>
          <h1>User Record: {email} ({userId})</h1>
        </div>
        <div className={styles.right} style={{
          display: "flex",
          alignItems: "center",
        }} onClick={() => navigate(-1)}>
          <div>Go Back</div>
          <div style={{
            display: "flex",
            alignItems: "center",
            fontSize: 20
          }}>
            <GoArrowRight />
          </div>
        </div>
      </div>

      <div className={styles['summary-container']}>
        <div className={styles['summary-card']}>
          <p className={styles['summary-title']}>Available Balance</p>
          <h2 className={styles['summary-amount']}>${parseFloat((balance.deposit + balance.withdraw).toFixed(3))} <span>USD</span></h2>
          <p className={styles['summary-sub']}>Withdrawal Balance: ${balance.withdraw} USD</p>
        </div>
        <div className={`${styles['summary-card']} ${styles.small}`}>
          <p className={styles['summary-title']}>Total Deposits</p>
          <h2 className={styles['summary-amount']}>${deposit} <span>USD</span></h2>
        </div>
        <div className={styles['summary-card']}>
          <p className={styles['summary-title']}>Total Withdrawals</p>
          <h2 className={styles['summary-amount']}>${withdraw} <span>USD</span></h2>
        </div>
        <div className={`${styles['summary-card']} ${styles.small}`}>
          <p className={styles['summary-title']}>Total Betting's</p>
          <h2 className={styles['summary-amount']}>${betting.amount} <span>USD</span></h2>
          <p className={styles['summary-sub']}>Company bet's count: {betting.company}</p>
        </div>
        <div className={`${styles['summary-card']} ${styles.small}`}>
          <p className={styles['summary-title']}>Total Winning's</p>
          <h2 className={styles['summary-amount']}>${winning.amount} <span>USD</span></h2>
          <p className={styles['summary-sub']}>Winning times: {winning.no}</p>
        </div>
      </div>

      <div className={styles['summary-container']}>
        <div className={styles['summary-card']}>
          <p className={styles['summary-title']}>Level 1 Team: &nbsp;&nbsp;&nbsp; {lv1.users} users </p>
          <h2 className={styles['summary-amount']}>${lv1.commission} <span>USD</span></h2>
          <p className={styles['summary-sub']}>Deposits: ${lv1.deposit} USD &nbsp;&nbsp;&nbsp;&nbsp;Withdrawals: ${lv1.withdraw} USD</p>
        </div>
        <div className={`${styles['summary-card']} ${styles.small}`}>
          <p className={styles['summary-title']}>Level 2 Team: &nbsp;&nbsp;&nbsp; {lv2.users} users </p>
          <h2 className={styles['summary-amount']}>${lv2.commission} <span>USD</span></h2>
          <p className={styles['summary-sub']}>Deposits: ${lv2.deposit} USD &nbsp;&nbsp;&nbsp;&nbsp;Withdrawals: ${lv2.withdraw} USD</p>
        </div>
        <div className={styles['summary-card']}>
          <p className={styles['summary-title']}>Level 3 Team: &nbsp;&nbsp;&nbsp; {lv3.users} users </p>
          <h2 className={styles['summary-amount']}>${lv3.commission} <span>USD</span></h2>
          <p className={styles['summary-sub']}>Deposits: ${lv3.deposit} USD &nbsp;&nbsp;&nbsp;&nbsp;Withdrawals: ${lv3.withdraw} USD</p>
        </div>
      </div>

      <div className={styles['button-group']}>
        {role === 'user' ? <button style={{ background: 'green' }} onClick={() => sendData(true)}>Promote</button> : role === 'Promoter first' ? <button style={{ background: 'green' }} onClick={() => sendData(true, true)}>Limit: 5$</button> : role === 'Promoter second' && <button style={{ background: 'green' }} onClick={() => sendData(true, true)}>Limit: {limit}$</button>}
        {(role === 'Promoter first' || role === 'Promoter second') && <button style={{ background: 'red'}} onClick={() => sendData(false)}>Demote</button>}
        <button onClick={() => navigate('/update/balance?userId=' + userId)}>Update Balance</button>
        <button onClick={() => navigate('/records/deposits')}>Deposit Records</button>
        <button onClick={() => navigate('/records/bets')}>Bet Records</button>
        <button onClick={() => navigate('/pending/withdrawal')}>Withdrawal Records</button>
      </div>
    </div>
  )
}

export default UserData